import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddressFields } from '@models/address';
import { LawFirm } from '@models/lawFirms';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';

export interface CreateOrUpdateLawFirmModel {
	name: string;
	lawFirm: LawFirm;
}

@Component({
	selector: 'app-create-lawfirm',
	templateUrl: './create.component.html',
	standalone: false,
})
export class CreateLawFirmComponent {
	public name;
	public id;
	public lawFirm: LawFirm;

	addressLabels = AddressFields;

	@SelectSnapshot(SelectedMatter.id) saleId;

	constructor(
		public dialogRef: MatDialogRef<CreateLawFirmComponent>,
		@Inject(MAT_DIALOG_DATA) public data: CreateOrUpdateLawFirmModel,
	) {
		this.name = data.name;
		this.lawFirm = data.lawFirm;
	}

	onSubmit(event) {
		this.dialogRef.close(event);
	}
}
